/* 🤖 this file was generated by svg-to-ts */
export const siriusTelegramLogo: {
  name: 'telegram_logo';
  data: string;
} = {
  name: 'telegram_logo',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.157 2.713a1.5 1.5 0 0 1 2.006 1.725v.004l-3.526 15.395a1.5 1.5 0 0 1-2.455.788h-.001l-3.69-3.247-2.425 2.426A1.5 1.5 0 0 1 7.5 18.75v-5.49l-4.395-.882h-.003c-1.441-.296-1.663-2.316-.254-2.868l17.306-6.797h.003ZM9 14.306v4.443l.004-.004 2.36-2.36L9 14.305Zm3.975 1.5a.776.776 0 0 0-.042-.038L9.45 12.705l11.12-8.032-3.396 14.828-.002-.002-4.198-3.694Zm-9.574-4.898v-.002l13.105-5.147-8.43 6.088-4.672-.938H3.4Z" fill="currentColor"/></svg>`
};
